<template>
  <settings-modal class="payment-bank-swift-edit-modal t-payment-bank-swift-edit-modal">
    <template slot="heading">Edit bank SWIFT</template>

    <p class="subheading red--text text-darken-2">Be informed that transaction will be resent via SCT after you press the button!</p>

    <v-text-field
      v-model="form.bankSwift"
      class="t-bank-swift-field"
      label="Bank SWIFT"
      :error-messages="getValidationErrorMessage('bankSwift')"
    />

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-save-button"
        color="primary"
        medium
        flat
        :disabled="loading || !isFormFilled || !hasBankSwiftChanged"
        @click="onSaveButtonClick"
      >save and resend</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentBankSwiftEditModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: { bankSwift: null },
        requiredFields: ['bankSwift'],
        paymentBankSwiftUpdateApiRequest: new ApiRequest(PaymentApi.updateBankSwiftBySupervisor)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      hasBankSwiftChanged () {
        return this.form.bankSwift !== this.currentBankSwift
      },
      paymentId () {
        return this.modal.data.paymentId
      },
      currentBankSwift () {
        return this.modal.data.bankSwift
      },
      loading () {
        return this.paymentBankSwiftUpdateApiRequest.loading
      },
      error () {
        return this.paymentBankSwiftUpdateApiRequest.error
      }
    },
    created () {
      this.setFieldValue('bankSwift', this.currentBankSwift)
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onSaveButtonClick () {
        this.editPaymentBankSwift(this.paymentId, this.form.bankSwift)
          .then(() => {
            this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Bank SWIFT has been successfully edited.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      editPaymentBankSwift (paymentId, bankSwift) {
        return this.paymentBankSwiftUpdateApiRequest.execute(paymentId, bankSwift)
      }
    }
  }
</script>
